import React, { useEffect, memo } from 'react';
import { updateWidgetProps } from '@components/common/EmpWidget/EMPWidgetContainer';
interface EmpSankeyPageProps {
  interval?: string;
  globalFilter?: any;
  eventName?: string;
  onModalClose?: () => void;
  onConvertToFunnel: (value: any) => void;
  onGoToUserTimeline: (convertObj: {
    userId?: string;
    clientId?: string;
    type: string;
    interval?: string;
  }) => void;
}

const EmpSankeyPage: React.FC<EmpSankeyPageProps> = ({
  interval,
  globalFilter,
  eventName,
  onModalClose,
  onConvertToFunnel,
  onGoToUserTimeline,
}) => {
  useEffect(() => {
    updateWidgetProps({
      widgetName: 'SankeyPage',
      style: { top: '2em' },
      destroyOnClose: true,
      interval,
      open: true,
      globalFilter,
      eventName,
      onModalClose,
      onConvertToFunnel,
      onGoToUserTimeline,
    });
    return () => {
      updateWidgetProps({
        widgetName: '',
        open: false,
      });
    };
  }, [interval, globalFilter, eventName, onModalClose, onConvertToFunnel, onGoToUserTimeline]);
  return null;
};

export default memo(EmpSankeyPage);
